import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, Ref, ref } from 'vue';

import {
  Chart as ChartJS,
  Tooltip,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
} from '@/libs/chart.js/dist/chart';
import { Line } from '@/libs/vue-chartjs/dist/index.js';

import { IPosition } from '@/types/IPosition';
import { formatDateHelper } from '@/helpers/main_helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'PositionsChart',
  props: {
    positions: null,
    paramKey: null,
    posParamKey: null,
    nextParamKey: null
  },
  setup(__props: any) {

const props = __props as {
  positions: IPosition[];
  paramKey: string;
  posParamKey: string;
  nextParamKey: string;
}



const SCALES: { [key: string]: { [key: string]: [number, number] } } = {
  rpms: {
    '2001': [2000, Infinity],
    '2000': [1900, 2000],
    '1900': [1800, 1900],
    '1800': [1700, 1800],
    '1700': [1600, 1700],
    '1600': [1500, 1600],
    '1500': [1400, 1500],
    '1400': [1300, 1400],
    '1300': [1200, 1300],
    '1200': [-Infinity, 1200],
  },
  engtmprs: {
    '96': [96, Infinity],
    '95': [86, 95],
    '85': [61, 85],
    '60': [41, 60],
    '40': [0, 40],
    '0': [-20, 0],
    '-20': [-30, -20],
    '-30': [-Infinity, -30],
  },
  hydoiltmprs: {
    '100': [100, Infinity],
    '90': [90, 100],
    '80': [60, 80],
    '60': [50, 60],
    '50': [30, 50],
    '30': [-Infinity, 30],
  },
};

const canvasBackgroundColorPlugin = {
  id: 'canvas-background-color',
  afterDraw(chart: any, args: any, pluginOptions: any) {
    const {
      ctx,
      chartArea: { left, top, width },
      scales: { yAxis: y },
      canvas,
    } = chart;

    const { paramKey, nextParamKey } = canvas.dataset;

    if (!paramKey || !nextParamKey) return;

    const [bracketLow, bracketHigh] = SCALES[paramKey][nextParamKey];

    bgColors(bracketLow, bracketHigh, 'rgba(255, 26, 104, 0.2)');

    function bgColors(bracketLow: number, bracketHigh: number, color: string) {
      const high =
        y.getPixelForValue(bracketHigh) < top
          ? top
          : y.getPixelForValue(bracketHigh);

      const low =
        y.getPixelForValue(bracketLow > y.min ? bracketLow : y.min) - high;

      ctx.fillStyle = color;
      ctx.fillRect(left, high, width, low);

      ctx.restore();
    }
  },
};

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  canvasBackgroundColorPlugin,
);

const chart: Ref<any> = ref(null);

const data = computed(() => {
  const labels = getTimeLabels();
  const points = getDataPoints();

  return {
    labels,
    datasets: [
      {
        data: points,
        cubicInterpolationMode: 'monotone',
        yAxisID: 'yAxis',
        fill: false,
        borderColor: '#1e2f97',
        pointBorderColor: '#1e2f97',
        pointBackgroundColor: '#1e2f97',
        tension: 0.1,
      },
    ],
  };
});
const options = computed(() => ({
  responsive: true,
  scales: {
    yAxis: {
      min: getYAxisMinValue(),
    },
  },
}));

const getYAxisMinValue = () => {
  const points = getDataPoints();
  const minPoint = Math.min(...points);
  return Math.min(minPoint, 0, +props.nextParamKey);
};

const getTimeLabels = () => {
  const labels = props.positions.map((pos) => {
    return formatDateHelper(new Date(pos.time), 'hh:nn:ss');
  });

  return labels;
};

const getDataPoints = () => {
  const dataArr: number[] = [];

  for (const pos of props.positions) {
    let val = pos[props.posParamKey];

    if (props.paramKey === 'engtmprs') {
      if (val === -40) {
        val = null;
      }
    }

    dataArr.push(val);
  }

  return dataArr;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Line), {
    ref_key: "chart",
    ref: chart,
    style: {"width":"100%","height":"80vh"},
    data: _unref(data),
    options: _unref(options),
    "data-param-key": props.paramKey,
    "data-next-param-key": props.nextParamKey
  }, null, 8, ["data", "options", "data-param-key", "data-next-param-key"]))
}
}

})